<template>
  <div class="CheckInput" :key="'check-input-' + item.kind + item.shortname">
    <!-- RRC : {{this.realResultsCount}} -->
    <div class="checkGroup">
      <input v-model="checked" @change="toggleFilter()" type="checkbox" :name="item.kind + item.shortname" :id="item.kind + item.shortname"/>
      <label :for="item.kind + item.shortname">
        <span class="checkIcon" :class="{ checked: checked }"></span>
        <span class="labelName">{{ item.name }} </span>
        <span v-if="initial && item.kind !== 'grades'">({{ this.realResultsCount || '0' }})</span>

        <span v-if="!initial && item.kind === 'type'">
          <template v-if="newTypeCount">
            ({{ this.newTypeCount[item.shortname] || '0' }})
          </template>
          <template v-else>
            ({{ this.realResultsCount || '0' }})
          </template>
        </span>

        <span v-if="!initial && item.kind === 'topics'">
          <template v-if="newTopicsCount">
            ({{ this.newTopicsCount[item.name] || '0' }})
          </template>
          <template v-else>
            ({{ this.realResultsCount || '0' }})
          </template>
        </span>

        <span v-if="!initial && item.kind === 'centuries'">
          <template v-if="newCenturiesCount">
            ({{ this.newCenturiesCount[item.shortname] || '0' }})
          </template>
          <template v-else>
            ({{ this.realResultsCount || '0' }})
          </template>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CheckInput',
  props: ['item'],
  computed: {
    ...mapGetters({
      activeFilters: 'getActiveFilters',
      facets: 'getFacets',
      locked: 'getLocked',
      showSpinner: 'getShowSpinner',
      initial: 'getInitial',
      newTypeCount: 'getNewTypeCount',
      newTopicsCount: 'getNewTopicsCount',
      newCenturiesCount: 'getNewCenturiesCount',

    }),
    realResultsCount: function () {
      // return this.facets[this.item.kind][this.item.shortname]
      if (this.facets && Object.keys(this.facets).length > 0 && this.facets[this.item.kind]) {
        if (this.item.kind === 'topics') {
          return this.facets[this.item.kind][this.item.name] || 0
        } else {
            return this.facets[this.item.kind][this.item.shortname] || 0
        }
      }
    },
  },
  data () {
    return {
      checked: false
    }
  },
  mounted: function () {
    this.listenFor('filter-tag-removed', arg => {
      if (arg === this.item.shortname) {
        this.checked = false
      }
    })

    this.listenFor('uncheck-all-filters', arg => {
      this.checked = false
    })

    var $this = this

    ///

    this.listenFor('initial-filters-topics', arg => {
      if ($this.item.kind === 'topics') {
        arg.forEach(el => {
          if ($this.item.name === el) {
            var filters = this.activeFilters
            filters.push($this.item)
            $this.$store.commit('updateActiveFilters', filters)
            $this.checked = true
          }
        })
      }
    })

    this.listenFor('initial-filters-type', arg => {
      if ($this.item.kind === 'type') {
        arg.forEach(el => {
          if ($this.item.shortname === el) {
            var filters = this.activeFilters
            filters.push($this.item)
            $this.$store.commit('updateActiveFilters', filters)
            $this.checked = true
          }
        })
      }
    })

    this.listenFor('initial-filters-centuries', arg => {
      if ($this.item.kind === 'centuries') {
        arg.forEach(el => {
          if ($this.item.shortname === el) {
            var filters = this.activeFilters
            filters.push($this.item)
            $this.$store.commit('updateActiveFilters', filters)
            $this.checked = true
          }
        })
      }
    })

    this.listenFor('initial-filters-grades', arg => {
      if ($this.item.kind === 'grades') {
        arg.forEach(el => {
          if ($this.item.shortname === el) {
            var filters = this.activeFilters
            filters.push($this.item)
            $this.$store.commit('updateActiveFilters', filters)
            $this.checked = true
          }
        })
      }
    })

    ///

    this.activeFilters.forEach(el => {
      if (el.shortname === this.item.shortname && el.kind === this.item.kind) {
        this.checked = true
      }
    })
  },
  watch: {
    checked: function () {
      if (!this.initial) {
        this.broadcast('requery')
      }
    }
  },
  methods: {
    toggleFilter: function () {
      this.$store.commit('updateCurrentPage', 1)
      var filters = this.activeFilters
      if (this.checked) {
        // console.log(this.item)
        filters.push(this.item)

      } else {
        var index = filters.indexOf(this.item)
        filters.splice(index, 1) // remove elements starting at given index limit 1
      }
      this.$store.commit('updateActiveFilters', filters)
      this.$store.commit('updateShowSpinner', true)
    }
  }
};
</script>

<style scoped lang="scss">
.CheckInput {
  label {
    font-size: 18px;
    font-weight: 500;
  }

  .checkIcon {
    position: relative;
    top: -3px;
    vertical-align: middle;
    display: inline-block;
    width: 25px;
    height: 25px;
    background-image: url('/themes/custom/microfiche/search/src/assets/notchecked.svg');
    background-repeat: no-repeat;
    background-size: 25px 25px;
    background-position: center center;
    margin-right: 10px;
    &.checked {
      background-image: url('/themes/custom/microfiche/search/src/assets/checked.svg');
    }
  }

  input {
    display: none;
  }
}
</style>
